<template>
    <div class="message-box" v-show="messageBoxShow">
        <section class="message-box-wrap">
            <h2>提示</h2>
            <p>{{message}}</p>
            <div class="btn-wrap">
                <span class="ensure-btn" @click.stop.prevent="handleEnsure">确定</span>
                <span class="cancle-btn" @click.stop.prevent="handleCancle">取消</span>
            </div>

        </section>
    </div>
</template>

<script>
    export default{
        name:'messageBox',
        data(){
            return {
                messageBoxShow:false
            }
        },
        props:{
            message:String,
            callBack:Function,
            callBackC:Function,
        },
        mounted(){

        },
        methods:{
            handleEnsure(){
                this.messageBoxShow = false;
                if(this.callBack!=null){
                    this.callBack()
                }
            },
            handleCancle(){
                this.messageBoxShow = false;
                if(this.callBackC!=null){
                    this.callBackC()
                }
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../resource/css/color";

    .message-box{
        font-size: .28rem;
        position: fixed;
        top:0;
        left: 0;
        right:0;
        bottom: 0;
        z-index: 9999999;
        background: rgba(0,0,0,.6);
    }
    .message-box-wrap{
        position: absolute;
        top: 50%;
        left: 50%;
        width: 5.3rem;
        padding: .4rem .22rem;
        background: #ffffff;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        border-radius: .2rem;
        h2{
            font-size: .28rem;
            text-align: center;
            padding-bottom: .4rem;
            border-bottom: 1px solid #e3e3e3;
        }
        p{
            text-align: center;
            line-height: .54rem;
            margin: .4rem 0;
            font-size: .24rem;
        }
        .btn-wrap{
            display: flex;
            margin: .28rem auto 0;
            justify-content: center;
            span{
                width: 2rem;
                display: block;
                color: #ffffff;
                line-height: .7rem;
                text-align: center;
                font-size: .32rem;
                margin: 0 .2rem;
                border-radius: .5rem;
            }
            .ensure-btn{
                background: $mainColor;
            }
            .cancle-btn{
                background: #666666;
            }
        }

    }
</style>


// WEBPACK FOOTER //
// src/components/messageBoxCancle/messageBoxCancle.vue